import React from 'react'
import { AdminSidebarLayout } from '../../components/AdminSidebar'
import { empty } from '../../assets/assets'
import { Link } from 'react-router-dom'
import { AdminHeader } from '../../components/components'
import HellociansTable from '../../components/Tables/HellociansTable'

const Hellocians = () => {
    return (

        <AdminSidebarLayout currentPath="/hellocians">
            <div className="bg-[#F5F5F5] dark:bg-[#0b0e14] min-h-screen px-4 py-8">
                <AdminHeader/>
                <div className="container mx-auto">
                    <HellociansTable/>
                </div>
            </div>
        </AdminSidebarLayout>
    )
}

export default Hellocians